import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=5f4b03cb"
import script from "./Catalog.vue?vue&type=script&lang=ts"
export * from "./Catalog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogFilterSortBar: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogFilterSortBar.vue').default,CatalogFilters: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogFilters.vue').default,CatalogSort: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogSort.vue').default,CatalogFilterStatusBar: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogFilterStatusBar.vue').default,CatalogPagination: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogPagination.vue').default,CatalogItems: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogItems.vue').default})
